(function () {
  "use strict";

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", run, { once: true });
  else run();

  function run() {
    initImagemenu();
    initImagemenuMobile();
  }

  function initImagemenu() {
    document.querySelectorAll("[data-imagemenu-toggler]").forEach((toggler) => {
      toggler.addEventListener(
        "click",
        toggleMenu.bind(null, toggler, "toggle")
      );

      toggler.addEventListener(
        "mouseenter",
        toggleMenu.bind(null, toggler, "show")
      );
    });

    const menuBackground = document.querySelector(
      "[data-imagemenu-background]"
    );

    menuBackground.addEventListener("click", (e) => {
      if (e.currentTarget === e.target) hideAllMenus();
    });

    menuBackground.addEventListener("mouseenter", hideAllMenus);

    for (const menuItem of document.querySelector(".header__icons").children) {
      if (!menuItem.hasAttribute("data-imagemenu-toggler"))
        menuItem.addEventListener("mouseenter", hideAllMenus);
    }

    window.addEventListener("keydown", (e) => {
      if (e.key === "Escape") hideAllMenus();
    });
  }

  function toggleMenu(toggler, mode) {
    const background = document.querySelector("[data-imagemenu-background]");
    const megamenu = document.getElementById(toggler.dataset.imagemenuToggler);
    const allMegamenus = Array.from(
      document.querySelectorAll("[data-imagemenu-group]")
    );
    const now = new Date();

    if (mode === "hide") {
      background.hidden = true;
      megamenu.hidden = true;
      return;
    }

    if (mode === "show") {
      allMegamenus.forEach((megamenu) => (megamenu.hidden = true));
      background.hidden = false;
      megamenu.hidden = false;
      toggler.dataset.showedTimestamp = now.valueOf().toString();
      return;
    }

    // mode is toggle

    if (!megamenu.hidden) {
      // Prevent from hiding when just showed 100ms ago. Solve the "'click' and 'mouseenter'
      // fired at the same time when the button is touched" issue.
      if (toggler.dataset.showedTimestamp) {
        const showedTimestamp = parseInt(toggler.dataset.showedTimestamp);
        const diff = now.valueOf() - showedTimestamp;

        if (diff < 200) return;
      }

      background.hidden = true;
      megamenu.hidden = true;
      return;
    }

    allMegamenus.forEach((megamenu) => (megamenu.hidden = true));
    background.hidden = false;
    megamenu.hidden = false;
    toggler.dataset.showedTimestamp = now.valueOf().toString();
  }

  function hideAllMenus() {
    document.querySelector("[data-imagemenu-background]").hidden = true;
    document
      .querySelectorAll("[data-imagemenu-group]")
      .forEach((megamenu) => (megamenu.hidden = true));
  }

  function initImagemenuMobile() {
    document
      .querySelectorAll("[data-imagemenu-accordion-toggler]")
      .forEach((element) => initAccordion(element));
  }

  function initAccordion(root) {
    const target = document.querySelector(
      "#" + root.dataset.imagemenuAccordionToggler
    );

    if (!target) return;

    accordionCalculateHeight(target);

    root.addEventListener("click", accordionToggle.bind(null, root, target));

    window.addEventListener(
      "resize",
      accordionCalculateHeight.bind(null, target)
    );
  }

  function accordionCalculateHeight(target) {
    target.style.setProperty("max-height", "none");
    target.style.setProperty("--height", target.offsetHeight + "px");
    target.style.removeProperty("max-height");
  }

  function accordionToggle(root, target, event) {
    event.preventDefault();

    if (root.getAttribute("aria-expanded") === "true") {
      root.removeAttribute("aria-expanded");
      target.setAttribute("hidden", "");
    } else {
      root.setAttribute("aria-expanded", "true");
      target.removeAttribute("hidden");
    }
  }
})();
